import { ControlledInput, icon } from "@hm/fundamental"
import { forwardRef } from "react"
import { useTranslation } from "react-i18next"

import { Comment } from "./comment"
import type { BaseControlledCommentBoxProps } from "./types"

export const BaseControlledCommentBox = forwardRef<
	HTMLInputElement,
	BaseControlledCommentBoxProps
>(
	(
		{
			comments,
			commentInputValue,
			onCommentInputChange,
			onSubmit,
			onEdit,
			onDelete,
			onDownloadAttachment,
			disabled = false,
		},
		ref,
	) => {
		const { t } = useTranslation("shared", { keyPrefix: "commentBox" })

		const submit = async () => {
			await onSubmit(commentInputValue)
		}

		return (
			<div data-cy="comment-component">
				<form
					data-cy="comment-form"
					onSubmit={async event => {
						event.preventDefault()
						event.stopPropagation()
						await submit()
					}}
				>
					<ControlledInput
						data-cy="comment-input"
						ref={ref}
						label={t("commentInputLabel")}
						name="comment"
						icon={icon.mdiSend}
						onIconClick={submit}
						value={commentInputValue}
						onChange={event =>
							onCommentInputChange(event.target.value)
						}
						isDisabled={disabled}
						autoComplete="off"
					/>
				</form>
				<div className="flex flex-col gap-y-6 mt-12px">
					{comments.map(comment => (
						<Comment
							key={comment.id}
							comment={comment}
							onEdit={content => onEdit(comment, content)}
							onDelete={() => onDelete(comment.id)}
							onDownloadAttachment={onDownloadAttachment}
						/>
					))}
				</div>
			</div>
		)
	},
)

BaseControlledCommentBox.displayName = "BaseControlledCommentBox"

export type {
	BaseControlledComment,
	BaseControlledCommentBoxProps,
	BaseCommentAttachment,
	BaseControlledCommentPill,
} from "./types"
